import { render, staticRenderFns } from "./AppTab.vue?vue&type=template&id=0a2b9ca8&scoped=true&"
import script from "./AppTab.vue?vue&type=script&lang=ts&"
export * from "./AppTab.vue?vue&type=script&lang=ts&"
import style0 from "./AppTab.vue?vue&type=style&index=0&id=0a2b9ca8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2b9ca8",
  null
  
)

export default component.exports